module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/2-2-c1f8a8308f574b262f02217d77b9cc4d.png";